import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information from "./_information";
import { FormProvider, useForm } from "react-hook-form";
import { Tenant, TenantForm } from "@/types/tenant.type";
import { useEditTenantMutation, useGetTenantQuery } from "@/services/tenant.service";

export default function EditTenant() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [editTenant, {isSuccess}] = useEditTenantMutation()
    const {data: tenant} = useGetTenantQuery(location.state.id || "", {refetchOnMountOrArgChange: true})
    const methods = useForm<TenantForm>()
    const {handleSubmit, setValue} = methods

    const onSubmit = handleSubmit((data: TenantForm) => {
        if (tenant) {
            editTenant({...data, gender: Number(data.gender), id: tenant.id} as Tenant)
        }
    })

    useEffect(() => {
        if (tenant) {
            setValue("no", tenant.no)
            setValue("name", tenant.name)
            setValue("type", tenant.type)
            setValue("fin_expiry", tenant.fin_expiry)
            setValue("gender", tenant.gender)
            setValue("nationality", tenant.nationality)
            setValue("email", tenant.email)
            setValue("contact_no", tenant.contact_no)
            setValue("access_card", tenant.access_card)
            tenant.identity_number && setValue("identity_number", tenant.identity_number)
        }
    }, [tenant])

    useEffect(() => {
        if(isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-sm rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("tenant.edit")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
